module.exports = __webpack_public_path__ + "static/media/java.367733ff.jpg";